import { useFormContext } from "react-hook-form";
import LazySelect, {
    ILazySelectProps,
} from "../../CardsPages/Forms/LazySelect";

export interface IFormLazySelectProps<T> extends ILazySelectProps<T> {
    // propriedade herdadas obrigatórias
    name: string;
    ref?: undefined;

    // outras propriedades
    wrapperClassName?: string;
}

export default function FormLazySelect<T>(props: IFormLazySelectProps<T>) {
    const { register, formState, setValue, watch } = useFormContext();

    const { wrapperClassName, registerOptions, ...selectProps } = props;

    return (
        <span className={wrapperClassName}>
            <LazySelect
                {...selectProps}
                setValue={setValue}
                watch={watch}
                className={`form-control placeholder-dark-75 ${
                    selectProps.className
                } ${formState.errors[selectProps.name] && "is-invalid"}`}
                ref={register(registerOptions)}
            />
            <div className="invalid-feedback">
                {formState.errors[selectProps.name]?.message ?? ""}
            </div>
        </span>
    );
}
